// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"243":"i18n0","256":"websocket","492":"vrgroup","664":"alarm-filter"}[chunkId] + "." + {"243":"727b96b58a8ef1ea14ea","256":"fe6e85037b9863c5515c","492":"152a38a3a11f0458a46d","664":"9c9d9c55fd088b18da2f"}[chunkId] + ".js";
};